import { MAX_VOLUME, MIN_VOLUME } from '@thriveglobal/thrive-web-core'

export const breathAnimationZIndex = 150
export const framesZIndex = 100

export const musicFadeDuration = 5

export const volumeLevelMin = MIN_VOLUME
export const volumeLevelMax = MAX_VOLUME
